import React from 'react';
import AnimatedSection from './AnimatedSection';
import './SharedStyles.css';
import './BlueprintOfGrowth.css';

const BlueprintOfGrowth = () => {
  const features = [
    { icon: '🚀', title: 'Diverse Portfolio', text: 'Creating products across different niches' },
    { icon: '📈', title: 'Growth Focus', text: 'Maximizing potential of top performers' },
    { icon: '🎯', title: 'Market Strategy', text: 'Identifying and scaling winning products' },
  ];

  return (
    <AnimatedSection direction="fade" className="blueprint-section" delay={200} id="blueprint">
      <div className="section-content-wrapper">
        <h2 className="section-title">
          Current <span className="title-accent">Strategy</span>
        </h2>
        <div className="content-card">
          <p className="lead-text">
            We focus on creating great products in different niches of mobile apps market, 
            growing to the maximum those of our products that have the biggest potential.
          </p>
          
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" style={{ '--delay': `${index * 100}ms` }}>
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-text">{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default BlueprintOfGrowth;
